import {
  Text,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Flex,
  Image,
  Circle,
  Box,
} from "@chakra-ui/react";
import { useSnapshot } from "valtio";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../utils/logout";
import { dashboardStore, userStore } from "../../../hooks/store";
import { UserWeddingRole } from "../../../types/wedding";
import { FC } from "react";

const ImageMenu: FC<{ settingsRoute: string }> = ({ settingsRoute }) => {
  const { data: dashboardData } = useSnapshot(dashboardStore);
  const { data: loggedInUserData } = useSnapshot(userStore);
  const navigate = useNavigate();

  const loggedInUserFirstName = loggedInUserData.firstname;
  const loggedInUserImage = loggedInUserData.profilePicture;
  const groomFirstName = dashboardData.groomFirstName;
  const brideFirstName = dashboardData.brideFirstName;
  const creatorRole = dashboardData.creatorRole;

  const primaryUser = {
    name:
      creatorRole === UserWeddingRole.Bride ? brideFirstName : groomFirstName,
    image: loggedInUserImage,
  };

  const goToSettings = () => navigate(settingsRoute);

  return (
    <Menu>
      <MenuButton
        as={Button}
        borderRadius={"full"}
        _focus={{ bg: "white" }}
        _active={{ bg: "white" }}
        _hover={{ bg: "white" }}
        bg="white"
        p={2}
        h="auto"
        // border={"1px solid #000"}
        fontFamily={"optima"}
      >
        <Flex alignItems="center" gap={2}>
          {/* Avatar */}
          {loggedInUserImage ? (
            <Image
              src={loggedInUserImage}
              w="32px"
              h="32px"
              borderRadius="full"
              objectFit="cover"
            />
          ) : (
            <Circle size="32px" bg="#E5DCC3" color="#000" fontWeight="bold">
              {primaryUser.name?.charAt(0) ||
                loggedInUserFirstName?.charAt(0) ||
                "U"}
            </Circle>
          )}

          {/* Text Section - Desktop Only */}
          <Box textAlign="left" display={{ base: "none", md: "block" }}>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="#000000"
              textTransform="uppercase"
              letterSpacing="0.5px"
            >
              {loggedInUserFirstName || primaryUser.name}
            </Text>
            <Text fontSize="xs" color="#666666" fontWeight="normal">
              Profile & settings
            </Text>
          </Box>
        </Flex>
      </MenuButton>

      <MenuList fontFamily={"font4"} zIndex={1000}>
        <MenuItem onClick={goToSettings}>Settings</MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ImageMenu;
